import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 22.3,
		cy: 15.5,
		r: 2.8,
		className: "icon-fill-secondary"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M32 13.1V9.7C32 4.4 27.6 0 22.3 0s-9.7 4.3-9.7 9.7v3.4H3.9v31.8h2.5V23.8h6.2v6h-1.3v2.5h1.3v1.6h-1.3v2.5h1.9l6 8.5h6l6.1-8.5h1.9v-2.5h-1.3v-1.6h1.3v-2.5h-1.3v-6h6.6v21.1H41V13.1h-9.1ZM22.3 2.6c3.3 0 6.1 2.2 6.9 5.2H15.4c.8-3 3.6-5.2 6.9-5.2ZM6.4 21.3v-5.7h6.2v5.7H6.4ZM24 42.4h-3.5l-4.3-6h12l-4.3 6Zm5.5-8.5H15.2v-1.6h14.3v1.6Zm-14.4-4.1V10.3h14.3v19.5H15.1ZM32 21.3v-5.7h6.6v5.7H32Z"
	})]
});
export default SvgIcon;
